import React from "react";

export default class ReminderWidget extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            reminder: props.reminder, 
        };
    }

    componentDidMount() {

    }

    componentDidUpdate() {
        if (this.props.reminder.id !== this.state.reminder.id) {
            this.setState({ reminder: this.props.reminder });
        }
    }

    render() {

        return (
            <section style={{ width: '100%', backgroundColor: 'white', display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center', borderBottom: '1px solid lightgrey' }}>
                <p style={{ flex: 1, fontWeight: 'bold', fontSize: 14, marginRight: 20 }}>{this.state.reminder.descrizione}</p>
                <div style={{ backgroundColor: '#5cb500', borderRadius: 5, width: 100, height: 30, padding: 10, cursor: 'pointer' }} onClick={() => this.props.onReminderDone(this.state.reminder)}>
                    <p style={{ color: 'white', fontWeight: 'bold', fontSize: 14, marginTop: -5, marginBottom: 10, width: '100%', textAlign: 'center' }}>{this.state.reminder.tipo === "commessa_in" ? "Ricevuto" : this.state.reminder.tipo === 'ordine' ? "Visualizza" : "Fatto"}</p>
                </div>
            </section>
        )
    }
}